import { axios } from '@/utils/request'

export function getAllNormalConfig (parameter = {}) {
  return axios({
    url: '/normalConfig/getAllNormalConfig',
    method: 'post',
    data: parameter
  })
}
